import styled from 'styled-components';
import { transition } from '../../../styles';

export const SearchButtonMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
  ${transition('background-color')}

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  > svg {
    flex: 0 0 24px;
  }

  &:hover {
    background-color: ${({ theme }): string => theme.COLOR.BLACK_08};
  }
`;
